export enum TransactionReportType {
  Account = 'ACCOUNT',
  MyTransactions = 'MY_TRANSACTIONS',
  Expenses = 'EXPENSES',
  Budget = 'BUDGET',
  ExpenseReport = 'EXPENSE_REPORT',
  NeedsApproval = 'NEEDS_APPROVAL',
  AccountingTransactions = 'ACCOUNTING_TRANSACTIONS',
  Other = 'OTHER',
}
